"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmbulatingType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var AmbulatingType_Factory = /** @class */ (function () {
    function AmbulatingType_Factory() {
    }
    AmbulatingType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    AmbulatingType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return AmbulatingType_Factory;
}());
exports.AmbulatingType_Factory = AmbulatingType_Factory;
